import { ApolloCache, ApolloError, BaseMutationOptions, DefaultContext, OperationVariables, gql, useMutation } from '@apollo/client';
import { GET_PATIENT_BY_ID } from '../../queries';
import { IOkPayload } from '../../types/mutations/generics';

interface ISetIsHealthCoachingEnabledInput {
  athenaId: string;
  isEnabled: boolean;
}

interface ISetIsHealthCoachingEnabledOutput {
  setIsHealthCoachingEnabled: IOkPayload;
}

const SET_HEALTHCOACH_ENABLED = gql`
  mutation setIsHealthCoachingEnabled($athenaId: String!, $isEnabled: Boolean!) {
    setIsHealthCoachingEnabled(athenaId: $athenaId, isEnabled: $isEnabled) {
      ok
    }
  }
`;

interface IUseSetIsHealthCoachingEnabled {
  athenaId: string;
  onError?: ((error: ApolloError, clientOptions?: BaseMutationOptions<any, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void) | undefined;
  onCompleted?:
    | ((data: ISetIsHealthCoachingEnabledOutput, clientOptions?: BaseMutationOptions<ISetIsHealthCoachingEnabledInput, OperationVariables, DefaultContext, ApolloCache<any>> | undefined) => void)
    | undefined;
}

export const useSetIsHealthCoachingEnabled = ({ athenaId, onError, onCompleted }: IUseSetIsHealthCoachingEnabled) => {
  const [mutate, { data, loading }] = useMutation<ISetIsHealthCoachingEnabledOutput, ISetIsHealthCoachingEnabledInput>(SET_HEALTHCOACH_ENABLED, {
    refetchQueries: [
      {
        query: GET_PATIENT_BY_ID,
        variables: {
          id: athenaId,
        },
      },
    ],
    awaitRefetchQueries: true,
    onError: onError,
    onCompleted: onCompleted,
  });

  return {
    mutate,
    data,
    loading,
  };
};
